export default __webpack_public_path__ + "static/media/construct6.8bbc5b52.jpg";